import { DatabaseService } from './database';

const databaseService = new DatabaseService(window.fetch.bind(window));
export default databaseService;
